import { Component } from '@angular/core';

@Component({
  selector: 'app-carriers-configurations',
  templateUrl: './carriers-configurations.component.html',
  styleUrls: ['./carriers-configurations.component.css'],
})
export class CarriersConfigurationsComponent {}
